import React, { useMemo } from "react";
import { preprocessMessage } from "../utils/textFormatting";
import { getMaskedContent, stripHtmlToText } from "../utils/masking";
import TypewriterText from "./TypewriterText";
import ResponseRenderer from "./ResponseRenderer";

const MessageContent = ({
  content,
  isHtml = false,
  isDarkMode,
  blurInfo,
  isTyping = false,
  messageId,
  onTypingComplete,
  onScroll,
}) => {
  const maskedData = useMemo(
    () => getMaskedContent(content, blurInfo),
    [content, blurInfo]
  );

  const displayContent = useMemo(() => {
    const base = isHtml
      ? stripHtmlToText(content)
      : blurInfo
        ? maskedData.text
        : content;
    return preprocessMessage(base);
  }, [content, isHtml, blurInfo, maskedData]);

  if (isTyping) {
    return (
      <TypewriterText
        text={displayContent}
        speed={25}
        onComplete={() => onTypingComplete?.(messageId)}
        onScroll={onScroll}
        isDarkMode={isDarkMode}
      />
    );
  }

  return <ResponseRenderer content={displayContent} isDarkMode={isDarkMode} />;
};

export default MessageContent;
